<template>
  <div id="app">
    <div
      v-if="!usingChrome"
      style="display:flex; flex-direction: column; justify-content: center; align-items: center; height: 100%"
    >
      <a href="https://www.google.co.jp/chrome/">
        <img src="@/assets/chrome-logo.svg" width="100" height="100" />
      </a>
      <h2>本サービス「ネイティブの口」はGoogle Chromeブラウザのみ対応しています。</h2>
      <p style="margin: 0">
        お使いのPCまたはMacにChromeブラウザがインストールされていない場合は、
        <a href="https://www.google.co.jp/chrome/">こちら</a>からダウンロードしてください。
      </p>
    </div>
    <Navbar ref="navbar" v-if="$store.state.auth.user && $route.path !== '/'" />
    <router-view
      @showChangeNicknameModal="showChangeNicknameModal"
      v-if="usingChrome"
      class="router-view"
    />
  </div>
</template>

<script>
export default {
  components: {
    Navbar: require("@/components/Navbar").default
  },
  data() {
    return {
      activeModalBg: false,
      usingChrome: false
    };
  },
  // computed: {
  //   styleObject() {
  //     return {

  //     };
  //   }
  // },
  methods: {
    showChangeNicknameModal() {
      this.$refs.navbar.showCangeNameModal();
    }
  },
  mounted() {
    let self = this;
    const { detect } = require("detect-browser");
    const browser = detect();
    const usingRightOs =
      browser.os === "Windows Vista" ||
      browser.os === "Windows 7" ||
      browser.os === "Windows 8" ||
      browser.os === "Windows 10" ||
      browser.os === "Windows 8.1" ||
      browser.os === "Mac OS";
    this.usingChrome = browser.name === "chrome" && usingRightOs;
  }
};
</script>

<style lang="scss" scoped>
#app {
  min-height: 100%;
}
.modal-bg {
  width: 100%;
  height: 100%;
  /* filter: blur(5px); */

  z-index: 15;
  position: fixed;
  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 100222000;
  }
}

.router-transition-enter-active {
  animation: fadeIn 0.3s;
  animation-delay: 0.3s;
  opacity: 0;
}

@keyframes fadeIn {
  from {
    /* transform: translateX(-20px); */
    opacity: 0;
  }
  to {
    /* transform: translateX(0); */
    opacity: 1;
  }
}

.router-transition-leave-active {
  animation: fadeOut 0.3s;
}

@keyframes fadeOut {
  from {
  }
  to {
    opacity: 0;
  }
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
  transition-delay: 0.3s;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
</style>
